export default "__VITE_ASSET__CCxMZbis__"